import { Navigate, useNavigate } from "react-router-dom";
import { t } from "ttag";

import { PHONE_NUMBERS } from "@/shared/models";
import { UserHeartRoundedIcon } from "@/shared/ui";
import { FUNNEL_ROUTE } from "../router/constants";
import { useFunnelStore } from "../stores";

/**
 * Terminal disqualification screen for the funnel. Reached when a patient
 * answers a hard-DQ question in a way that excludes them from treatment
 * (matches the messaging of the normal onboarding, styled for this funnel).
 */
export const Disqualified = () => {
  const navigate = useNavigate();
  const initialWeight = useFunnelStore((store) => store.initialWeight);

  if (initialWeight === undefined) {
    return <Navigate to={FUNNEL_ROUTE.MEASUREMENTS} replace />;
  }

  return (
    <div className="mx-auto flex w-full max-w-2xl flex-col items-center px-5 py-16 text-center">
      <span className="flex size-16 items-center justify-center rounded-full bg-secondary-100 text-secondary-500">
        <UserHeartRoundedIcon className="size-8" />
      </span>

      <h1 className="mt-8 text-3xl leading-tight font-extrabold text-primary-950 sm:text-4xl">
        {t`levelsRx treatment may not be the best fit for you right now`}
      </h1>

      <p className="mt-4 text-lg text-primary-950">
        {t`Based on your answers, we're unable to offer treatment at this time. Your safety is our top priority. If you think this was a mistake, you can go back and review your answers.`}
      </p>

      <p className="mt-6 text-base text-primary-950">
        {t`If you're in crisis, please contact the 988 Suicide and Crisis Lifeline by calling or texting 988.`}
      </p>

      <p className="mt-6 text-base text-neutral-600">
        {t`Questions? Contact us at`}{" "}
        <a
          href="mailto:support@levelsrx.com"
          className="text-primary-950 underline"
        >
          support@levelsrx.com
        </a>{" "}
        |{" "}
        <a
          href={PHONE_NUMBERS.CUSTOMER_SUPPORT.TEL_HREF}
          className="text-primary-950"
        >
          {PHONE_NUMBERS.CUSTOMER_SUPPORT.NUMBER}
        </a>
      </p>

      <button
        type="button"
        onClick={() => navigate(-1)}
        className="mt-10 flex w-full max-w-sm items-center justify-center rounded-full bg-primary-950 px-8 py-4 text-lg font-medium text-white transition hover:bg-primary-900 active:bg-primary-800"
      >
        {t`Back to previous step`}
      </button>
    </div>
  );
};
